// La confirmación de D-13. Va en `Modal` (capa registrada: «atrás» la
// cierra) y no en `ModalConfirmar` porque aquí el botón secundario no es
// «Cancelar»: es «Quedarme», que es lo que la persona está decidiendo.
import { CloudOff } from 'lucide-react';
import Modal from '../../ui/Modal';
import { textosDeSalida } from './salidaConPendientes';

const BOTON = 'min-h-11 px-4 rounded-lg text-sm font-semibold focus:outline-none focus:ring-2 focus:ring-[var(--color-marca)]';

export default function SalidaConPendientes({ pendientes, onCerrarSesion, onQuedarme }) {
  const t = textosDeSalida(pendientes);
  return (
    <Modal
      titulo={t.titulo}
      icono={CloudOff}
      onCerrar={onQuedarme}
      guardia={false}
      pie={(
        <div className="flex flex-wrap items-center justify-end gap-2 p-4 border-t border-gray-200">
          <button type="button" onClick={onQuedarme} className={`${BOTON} bg-[var(--color-marca)] text-white`}>{t.quedarme}</button>
          <button type="button" onClick={onCerrarSesion} className={`${BOTON} border border-gray-300 bg-white text-gray-800`}>{t.cerrar}</button>
        </div>
      )}
    >
      <p className="text-sm text-gray-700">{t.descripcion}</p>
    </Modal>
  );
}
